
var XML_CHARACTER_MAP = {
    '&': '&',
    '"': '"',
    "'": "'",
    '<': '<',
    '>': '>'
};

function escapeForXML(string) {
    return string && string.replace
        ? string.replace(/([&"<>'])/g, function(str, item) {
            return XML_CHARACTER_MAP[item];
          })
        : string;
}

module.exports = escapeForXML;



//////////////////
// WEBPACK FOOTER
// ./~/xml/lib/escapeForXML.js
// module id = s1dE
// module chunks = 0